import React from 'react';
import Stepper from "../Stepper";
import CustomButton from "../CustomButton";
import iconArrowRight from "url:shared-assets/icons/black/arrow-right.svg";
import {useNavigate} from "react-router";


interface Props {
  status: string;
  multipleRequest: boolean;
  partial: boolean;
  language: string;
  surveyRequestId: string;
  visionStatementId?: string;
  deadline: string;
  readOnly?: boolean;
}

const RequestStatus: React.FC<Props> = (props: Props) => {

  const navigate = useNavigate();
  const lang = props.language;

  const myNavigate = (link: string) => {
    if (props.surveyRequestId === "0") {
      alert("This is debug page. Would send client to " + link);
    } else {
      navigate(link);
    }
  }

  const singleRequest = () => {

    let description1 = lang === "sv" ? "Klar" : "Completed";
    let description2 = lang === "sv" ? "Be om feedback"
      : "Send a request to those around you";
    let description3 = lang === "sv" ? "Resultat och analys av din självskattning och feedback"
      : "Results and analysis from your self-assessment and feedback";

    let buttonText = "";
    let buttonType: "blueBase"|"outlineWhiteBase" = "blueBase";
    let navigateTo = "";

    let step = 0;
    let completedSteps: Array<number> = [];

    if (props.status === "completed") {
      completedSteps = [0, 1, 2];
      step = 3
    } else if (props.status === "pending_self") {
      description1 = lang === "sv" ? "Slutför din självskattning" : "Complete your self-assessment to continue";
      buttonText = lang === "sv" ? "Fortsätt med självskattning" : "Continue with self-assessment";

      if (props.partial) {
        navigateTo = "/assessments/own/" + props.visionStatementId;
      } else {
        navigateTo = "/feedback/survey/" + props.surveyRequestId;
      }
    } else if (props.status === "invite_other") {
      completedSteps = [0];
      step = 1
      description2 = lang === "sv" ? "Be om feedback" : "Request feedback";
      description3 = lang === "sv" ? "Väntar på svar. Vi meddelar dig via e-post när den är klar, troligen senast "
        : "Waiting for feedback result. We'll email you when it is ready, no later than ";
      description3 += props.deadline.substring(0, 10) + ".";
      buttonText = lang === "sv" ? "Be om feedback" : "Request feedback";
      if (props.partial) {
        navigateTo = "/assessments/own/" + props.visionStatementId;
      } else {
        navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
      }
    } else if (props.status === "pending_other") {
      completedSteps = [0, 1];
      step = 2
      description2 = lang === "sv" ? "Feedbackförfrågan skickad" : "Feedback request sent";
      description3 = lang === "sv" ? "Väntar på svar. Vi meddelar dig via e-post när den är klar, troligen senast "
        : "Waiting for feedback result. We'll email you when it is ready, no later than ";
      description3 += props.deadline.substring(0, 10) + ".";
    } else if (props.status === "failed_resend") {
      buttonText = lang === "sv" ? "Be om feedback igen" : "Ask for feedback again"
      if (props.partial) {
        navigateTo = "/assessments/own/" + props.visionStatementId;
      } else {
        navigateTo = "/dev-plan/survey_request_invite/" + props.surveyRequestId;
      }
    }

    const title3 = props.partial ?
      lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" :
      lang === "sv" ? "Insiktsrapport" : "Insights report";


    const stepsData = [
      {
        title: lang === "sv" ? "Självskattning" : "Self-assessment",
        description: description1,
        content: null,
      },
      {
        title: lang === "sv" ? "Feedback": "Feedback request",
        description: description2,
        content: null,
      },
      {
        title: title3,
        description: description3,
        content: null,
      },
    ];


    return (
      <div className="mt-4 px-4 pb-4 bg-indigo-800 rounded-sm">
        {
          props.status === "failed_resend" ? (
            <div className="pt-4">{lang === "sv" ? "Alla svarade inte i tid. Du kan prova att be om feedback igen från de som inte svarat." :
              "Everybody didn't respond in time. You can try to ask again from they who didn't respond"}</div>
          ) : (
            <Stepper
              steps={stepsData}
              direction="vertical"
              currentIndex={step}
              completedSteps={completedSteps}
            />
          )
        }

        {
          (buttonText.length > 0) &&
            <div className="flex justify-end mt-4">
                <CustomButton buttonType={buttonType} disabled={props.readOnly} style={{width: "unset"}}
                              rightIcon={buttonType === "blueBase" ? <img src={iconArrowRight} alt="right"/> : null}
                              onClick={() => myNavigate(navigateTo)}>
                  {buttonText}
                </CustomButton>
            </div>
        }

      </div>
    )
  }

  const multipleRequest = () => {

    if (props.status === "invite_other" || props.partial) {
      return <div className="text-amber-600">This state does not exist for automatic surveys</div>
    }

    let buttonText = "";
    let buttonType: "blueBase"|"outlineWhiteBase" = "blueBase";
    let navigateTo = "";

    let description1 = lang === "sv" ? "Klar" : "Completed";
    let description2 = lang === "sv" ? "Resultat och analys av din självskattning och feedback"
      : "Results and analysis from your self-assessment and feedback";

    let step = 0;
    let completedSteps: Array<number> = [];

    if (props.status === "completed") {
      completedSteps = [0, 1];
      step = 2
    } else if (props.status === "pending_self") {
      description1 = lang === "sv" ? "Ge feedback" : "Give feedback";
      buttonText = lang === "sv" ? "Ge feedback" : "Give feedback";
      navigateTo = "/feedback/survey_multi/" + props.surveyRequestId;
    } else if (props.status === "pending_other") {
      completedSteps = [0];
      step = 1
      description2 = lang === "sv" ? "Väntar på svar. Vi meddelar dig via e-post när den är klar, troligen senast "
        : "Waiting for feedback result. We'll email you when it is ready, no later than ";
      description2 += props.deadline.substring(0, 10) + ".";
    }

    const title2 = props.partial ?
      lang === "sv" ? "Feedbackresultat och analys" : "Feedback result and analysis" :
      lang === "sv" ? "Insiktsrapport" : "Insights report";


    const stepsData = [
      {
        title: "Feedback",
        description: description1,
        content: null,
      },
      {
        title: title2,
        description: description2,
        content: null,
      },
    ];


    return (
      <div className="mt-4 px-4 pb-4 bg-indigo-800 rounded-sm">
        {
          props.status === "failed_resend" ? (
            <div>Failed resend</div>
          ) : (
            <Stepper
              steps={stepsData}
              direction="vertical"
              currentIndex={step}
              completedSteps={completedSteps}
            />
          )
        }
        <Stepper
          steps={stepsData}
          direction="vertical"
          currentIndex={step}
          completedSteps={completedSteps}
        />

        {
          (buttonText.length > 0) &&
            <div className="flex justify-end mt-4">
                <CustomButton buttonType={buttonType} style={{width: "unset"}}
                              rightIcon={buttonType === "blueBase" ? <img src={iconArrowRight} alt="right"/> : null}
                              onClick={() => myNavigate(navigateTo)}>
                  {buttonText}
                </CustomButton>
            </div>
        }

      </div>
    )
  }

  if (props.status === "completed") {
    return <div className="mt-4 p-4 bg-indigo-800 rounded-sm">Feedback completed - would show results here</div>
  }

  if (props.status === "failed_old") {
    return <div className="mt-4 p-4 bg-indigo-800 rounded-sm">
      Your feedback request did not complete in 3 months after deadline. Would show link to create new feedback request
    </div>
  }

  if (props.multipleRequest) {
    return <>{multipleRequest()}</>
  } else {
    return <>{singleRequest()}</>
  }
}

export default RequestStatus;